var _defs, _path, _g, _path2, _path3, _g2, _g3, _g4, _g5, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{clip-path:url(#clip-path-3);}.cls-6{clip-path:url(#clip-path-4);}.cls-7{clip-path:url(#clip-path-5);}.cls-8{clip-path:url(#clip-path-6);}.cls-9{clip-path:url(#clip-path-7);}.cls-10{clip-path:url(#clip-path-8);}.cls-11{clip-path:url(#clip-path-9);}.cls-12{clip-path:url(#clip-path-10);}.cls-13{clip-path:url(#clip-path-11);}.cls-14{clip-path:url(#clip-path-12);}.cls-15{clip-path:url(#clip-path-13);}.cls-16{clip-path:url(#clip-path-14);}.cls-17{clip-path:url(#clip-path-15);}.cls-18{clip-path:url(#clip-path-16);}.cls-19{clip-path:url(#clip-path-17);}.cls-20{clip-path:url(#clip-path-18);}.cls-21{clip-path:url(#clip-path-19);}.cls-22{clip-path:url(#clip-path-20);}.cls-23{clip-path:url(#clip-path-21);}.cls-24{clip-path:url(#clip-path-22);}.cls-25{clip-path:url(#clip-path-23);}.cls-26{clip-path:url(#clip-path-24);}.cls-27{fill:#1668a5;}.cls-28{fill:#e1ce27;}.cls-29{clip-path:url(#clip-path-25);}.cls-30{clip-path:url(#clip-path-26);}.cls-31{clip-path:url(#clip-path-27);}.cls-32{fill:#d04090;}.cls-33{clip-path:url(#clip-path-29);}.cls-34{fill:#00aabd;}.cls-35{clip-path:url(#clip-path-31);}.cls-36{fill:#e1ce2b;}.cls-37{fill:#c9c9c8;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.16-132.26a2.25,2.25,0,0,1-2.09,1.42,2.26,2.26,0,0,1-2.28-2.25,2.27,2.27,0,0,1,2.26-2.28,2.25,2.25,0,0,1,2.1,1.41,1.74,1.74,0,0,1,1-.71,3.47,3.47,0,0,0-3.09-1.89,3.46,3.46,0,0,0-3.46,3.44,3.47,3.47,0,0,0,3.46,3.48,3.5,3.5,0,0,0,3.09-1.91,1.79,1.79,0,0,1-1-.71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.71-133.11a1,1,0,0,1-1,1,1,1,0,0,1-1-1,1,1,0,0,1,1-1,1.05,1.05,0,0,1,1,1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.18-133.12a1,1,0,0,1-1,1,1,1,0,0,1-1-1,1,1,0,0,1,1-1,1,1,0,0,1,1,1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.06-133a3.59,3.59,0,0,0,.49.91l0,0v0a1.47,1.47,0,0,0,1.11.5,1.5,1.5,0,0,0,1.05-.43,1.47,1.47,0,0,0,.43-1,1.5,1.5,0,0,0-.43-1.05,1.47,1.47,0,0,0-1-.43,1.5,1.5,0,0,0-1.41,1h0s-.1.26-.22.53m-1.63-1.53a1.71,1.71,0,0,0-.29,0,1.48,1.48,0,0,0-1.49,1.48,1.5,1.5,0,0,0,.43,1.05,1.47,1.47,0,0,0,1,.43,1.51,1.51,0,0,0,1.11-.49l0,0a3.66,3.66,0,0,0,.5-.91c-.11-.26-.19-.48-.21-.53v0a1.5,1.5,0,0,0-1.12-1m-.64,3.19a1.77,1.77,0,0,1-1.42-1.73,1.77,1.77,0,0,1,1.77-1.76,1.76,1.76,0,0,1,1.66,1.19v0l.1.26.1-.26h0a1.76,1.76,0,0,1,1.67-1.19,1.72,1.72,0,0,1,1.24.52,1.75,1.75,0,0,1,.51,1.25,1.72,1.72,0,0,1-.52,1.24,1.75,1.75,0,0,1-1.25.51,1.76,1.76,0,0,1-1.31-.59h0a2.91,2.91,0,0,1-.45-.76,3.14,3.14,0,0,1-.45.76h0a1.77,1.77,0,0,1-1.32.58,1.65,1.65,0,0,1-.33,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308-126.9a5.06,5.06,0,0,1-4.71,3.19,5.08,5.08,0,0,1-5.13-5.06,5.11,5.11,0,0,1,5.09-5.13,5.06,5.06,0,0,1,4.73,3.18,3.91,3.91,0,0,1,2.23-1.61,7.8,7.8,0,0,0-6.94-4.26,7.78,7.78,0,0,0-7.78,7.75A7.81,7.81,0,0,0,303.3-121a7.88,7.88,0,0,0,7-4.31A4,4,0,0,1,308-126.9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M313.77-128.82a2.35,2.35,0,0,1-2.36,2.34,2.35,2.35,0,0,1-2.34-2.36,2.35,2.35,0,0,1,2.36-2.34,2.36,2.36,0,0,1,2.34,2.36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M305.81-128.84a2.35,2.35,0,0,1-2.36,2.34,2.35,2.35,0,0,1-2.34-2.36,2.35,2.35,0,0,1,2.36-2.34,2.33,2.33,0,0,1,2.34,2.36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.78-128.66a8.09,8.09,0,0,0,1.1,2l0,0,0,0a3.31,3.31,0,0,0,2.5,1.12,3.38,3.38,0,0,0,2.37-1,3.31,3.31,0,0,0,1-2.36,3.38,3.38,0,0,0-1-2.37,3.31,3.31,0,0,0-2.36-1,3.37,3.37,0,0,0-3.18,2.25v0c-.05.1-.23.59-.49,1.19m-3.66-3.44a3.85,3.85,0,0,0-.65-.07,3.34,3.34,0,0,0-3.35,3.33,3.38,3.38,0,0,0,1,2.37,3.31,3.31,0,0,0,2.36,1,3.41,3.41,0,0,0,2.5-1.1l.05-.05a8.23,8.23,0,0,0,1.12-2c-.24-.59-.42-1.08-.47-1.2l0-.05a3.37,3.37,0,0,0-2.51-2.16m-1.43,7.17a4,4,0,0,1-3.19-3.89,4,4,0,0,1,4-4,4,4,0,0,1,3.73,2.67l0,0c.07.17.14.38.23.59.09-.21.16-.42.23-.59v0a4,4,0,0,1,3.75-2.67,3.88,3.88,0,0,1,2.79,1.17,3.93,3.93,0,0,1,1.15,2.81,3.88,3.88,0,0,1-1.17,2.79,3.93,3.93,0,0,1-2.81,1.15,4,4,0,0,1-2.95-1.33l0,0a6.55,6.55,0,0,1-1-1.71,7.07,7.07,0,0,1-1,1.71l0,0a4,4,0,0,1-3,1.31,3.7,3.7,0,0,1-.73-.07"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.8-106.78a3.4,3.4,0,0,1-3.16,2.14,3.41,3.41,0,0,1-3.44-3.4,3.43,3.43,0,0,1,3.42-3.44,3.4,3.4,0,0,1,3.17,2.13,2.63,2.63,0,0,1,1.5-1.08,5.23,5.23,0,0,0-4.66-2.86,5.22,5.22,0,0,0-5.22,5.2,5.24,5.24,0,0,0,5.22,5.26,5.28,5.28,0,0,0,4.67-2.89,2.7,2.7,0,0,1-1.5-1.07"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.66-108.07a1.58,1.58,0,0,1-1.58,1.57,1.58,1.58,0,0,1-1.57-1.58,1.58,1.58,0,0,1,1.58-1.57,1.59,1.59,0,0,1,1.57,1.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.32-108.08a1.58,1.58,0,0,1-1.58,1.57,1.58,1.58,0,0,1-1.57-1.58,1.58,1.58,0,0,1,1.58-1.57,1.56,1.56,0,0,1,1.57,1.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.64-108a5.43,5.43,0,0,0,.74,1.37l0,0v0a2.22,2.22,0,0,0,1.67.75,2.27,2.27,0,0,0,1.59-.66,2.22,2.22,0,0,0,.66-1.58,2.27,2.27,0,0,0-.66-1.59,2.22,2.22,0,0,0-1.58-.66,2.26,2.26,0,0,0-2.13,1.51h0c0,.07-.15.4-.33.8m-2.46-2.31a2.58,2.58,0,0,0-.43,0,2.24,2.24,0,0,0-2.25,2.24,2.27,2.27,0,0,0,.66,1.59,2.22,2.22,0,0,0,1.58.66,2.29,2.29,0,0,0,1.67-.74l0,0a5.52,5.52,0,0,0,.75-1.37c-.16-.4-.28-.73-.32-.81v0a2.26,2.26,0,0,0-1.69-1.45m-1,4.81a2.67,2.67,0,0,1-2.14-2.61,2.67,2.67,0,0,1,2.67-2.66,2.66,2.66,0,0,1,2.51,1.79v0c0,.12.09.26.15.4.06-.14.11-.28.15-.4h0a2.66,2.66,0,0,1,2.52-1.79,2.6,2.6,0,0,1,1.87.78,2.64,2.64,0,0,1,.77,1.89,2.6,2.6,0,0,1-.78,1.87,2.64,2.64,0,0,1-1.89.77,2.65,2.65,0,0,1-2-.89h0a4.39,4.39,0,0,1-.68-1.15,4.74,4.74,0,0,1-.68,1.15h0a2.67,2.67,0,0,1-2,.88,2.49,2.49,0,0,1-.49,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310-385.75a9.8,9.8,0,0,1-9.12,6.18,9.83,9.83,0,0,1-9.93-9.79,9.88,9.88,0,0,1,9.86-9.93,9.8,9.8,0,0,1,9.15,6.15,7.57,7.57,0,0,1,4.32-3.11,15.1,15.1,0,0,0-13.44-8.24,15.06,15.06,0,0,0-15.06,15,15.12,15.12,0,0,0,15.06,15.16,15.24,15.24,0,0,0,13.47-8.34,7.79,7.79,0,0,1-4.32-3.07"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321.11-389.47a4.55,4.55,0,0,1-4.56,4.53A4.55,4.55,0,0,1,312-389.5a4.55,4.55,0,0,1,4.56-4.53,4.58,4.58,0,0,1,4.53,4.56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M305.71-389.5a4.55,4.55,0,0,1-4.56,4.53,4.55,4.55,0,0,1-4.53-4.56,4.55,4.55,0,0,1,4.56-4.53,4.51,4.51,0,0,1,4.53,4.56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M309.53-389.16a15.65,15.65,0,0,0,2.13,4l.07.07,0,.07a6.4,6.4,0,0,0,4.83,2.16,6.55,6.55,0,0,0,4.59-1.89,6.41,6.41,0,0,0,1.89-4.56,6.55,6.55,0,0,0-1.89-4.59,6.41,6.41,0,0,0-4.56-1.89,6.52,6.52,0,0,0-6.15,4.36v0c-.1.2-.44,1.15-.95,2.3m-7.09-6.65a7.45,7.45,0,0,0-1.25-.14,6.46,6.46,0,0,0-6.48,6.45,6.55,6.55,0,0,0,1.89,4.59,6.41,6.41,0,0,0,4.56,1.89,6.6,6.6,0,0,0,4.83-2.13l.1-.1a15.93,15.93,0,0,0,2.16-4c-.47-1.15-.81-2.09-.91-2.33l0-.1a6.52,6.52,0,0,0-4.86-4.19m-2.77,13.88a7.71,7.71,0,0,1-6.18-7.53,7.71,7.71,0,0,1,7.7-7.67,7.67,7.67,0,0,1,7.23,5.17l0,.07c.14.34.27.74.44,1.15.17-.41.3-.81.44-1.15v0a7.67,7.67,0,0,1,7.26-5.17,7.5,7.5,0,0,1,5.4,2.26,7.61,7.61,0,0,1,2.23,5.44A7.5,7.5,0,0,1,322-384a7.61,7.61,0,0,1-5.44,2.23,7.65,7.65,0,0,1-5.71-2.57l0,0a12.67,12.67,0,0,1-2-3.31,13.68,13.68,0,0,1-2,3.31l0,0a7.7,7.7,0,0,1-5.74,2.53,7.17,7.17,0,0,1-1.42-.14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.87-57.14a4.36,4.36,0,0,1-4.06,2.75,4.37,4.37,0,0,1-4.42-4.36,4.4,4.4,0,0,1,4.39-4.42,4.36,4.36,0,0,1,4.07,2.73,3.37,3.37,0,0,1,1.92-1.38,6.72,6.72,0,0,0-6-3.67A6.7,6.7,0,0,0,5.1-58.8a6.73,6.73,0,0,0,6.7,6.74,6.78,6.78,0,0,0,6-3.71,3.47,3.47,0,0,1-1.92-1.37"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.81-58.79a2,2,0,0,1-2,2,2,2,0,0,1-2-2,2,2,0,0,1,2-2,2,2,0,0,1,2,2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14-58.8a2,2,0,0,1-2,2,2,2,0,0,1-2-2,2,2,0,0,1,2-2,2,2,0,0,1,2,2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.66-58.65a7,7,0,0,0,.95,1.76l0,0,0,0a2.85,2.85,0,0,0,2.15,1,2.91,2.91,0,0,0,2-.84,2.85,2.85,0,0,0,.84-2,2.91,2.91,0,0,0-.84-2,2.85,2.85,0,0,0-2-.84,2.9,2.9,0,0,0-2.73,1.94v0c0,.09-.2.51-.42,1m-3.15-3a3.31,3.31,0,0,0-.56-.06A2.87,2.87,0,0,0,9.06-58.8a2.91,2.91,0,0,0,.84,2,2.85,2.85,0,0,0,2,.84,2.94,2.94,0,0,0,2.15-.95l0,0a7.09,7.09,0,0,0,1-1.76c-.21-.51-.36-.93-.41-1l0,0a2.9,2.9,0,0,0-2.16-1.86m-1.23,6.17a3.43,3.43,0,0,1-2.75-3.35,3.43,3.43,0,0,1,3.42-3.41,3.41,3.41,0,0,1,3.21,2.3l0,0c.06.15.12.33.2.51.08-.18.14-.36.2-.51v0a3.41,3.41,0,0,1,3.23-2.3,3.34,3.34,0,0,1,2.4,1,3.38,3.38,0,0,1,1,2.42,3.34,3.34,0,0,1-1,2.4,3.38,3.38,0,0,1-2.42,1,3.41,3.41,0,0,1-2.54-1.14l0,0A5.64,5.64,0,0,1,15.34-58a6.09,6.09,0,0,1-.87,1.47l0,0a3.42,3.42,0,0,1-2.55,1.13,3.19,3.19,0,0,1-.63-.06"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.69,26.61a4.33,4.33,0,1,1,0-3.24A3.32,3.32,0,0,1,240.57,22a6.61,6.61,0,1,0,0,5.95,3.41,3.41,0,0,1-1.89-1.35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.56,25a2,2,0,1,1-2-2,2,2,0,0,1,2,2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.81,25a2,2,0,1,1-2-2,2,2,0,0,1,2,2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.49,25.11a6.86,6.86,0,0,0,.93,1.73l0,0v0a2.8,2.8,0,0,0,2.12.95,2.87,2.87,0,0,0,2-.83,2.81,2.81,0,0,0,.83-2,2.87,2.87,0,0,0-.83-2,2.81,2.81,0,0,0-2-.83,2.86,2.86,0,0,0-2.69,1.91h0c0,.09-.19.5-.41,1m-3.11-2.92a3.26,3.26,0,0,0-.55-.06A2.83,2.83,0,0,0,232,25a2.87,2.87,0,0,0,.83,2,2.81,2.81,0,0,0,2,.83,2.89,2.89,0,0,0,2.12-.93l0,0a7,7,0,0,0,.95-1.73c-.21-.5-.36-.92-.4-1v0a2.86,2.86,0,0,0-2.13-1.83m-1.21,6.08A3.36,3.36,0,1,1,238,23.88v0c.06.15.12.33.19.5.07-.18.13-.36.19-.5h0a3.36,3.36,0,0,1,3.18-2.26,3.29,3.29,0,0,1,2.37,1,3.33,3.33,0,0,1,1,2.38,3.29,3.29,0,0,1-1,2.37,3.37,3.37,0,0,1-4.88-.15h0a5.55,5.55,0,0,1-.86-1.45,6,6,0,0,1-.86,1.45h0a3.37,3.37,0,0,1-2.52,1.11,3.14,3.14,0,0,1-.62-.06"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37,30.47a3.6,3.6,0,1,1,0-2.69,2.76,2.76,0,0,1,1.57-1.13,5.5,5.5,0,1,0,0,4.94A2.84,2.84,0,0,1,37,30.47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -316.44,
    y: -43.27,
    width: 518.06,
    height: 314.07
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.08,29.12a1.65,1.65,0,1,1-1.65-1.66,1.66,1.66,0,0,1,1.65,1.66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.47,29.11a1.65,1.65,0,1,1-1.65-1.66,1.66,1.66,0,0,1,1.65,1.66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.86,29.23a5.7,5.7,0,0,0,.77,1.44l0,0v0a2.33,2.33,0,0,0,1.76.79,2.39,2.39,0,0,0,1.67-.69,2.34,2.34,0,0,0,.69-1.66,2.39,2.39,0,0,0-.69-1.67,2.34,2.34,0,0,0-1.66-.69,2.37,2.37,0,0,0-2.24,1.59h0c0,.07-.16.42-.34.84m-2.58-2.42a2.71,2.71,0,0,0-.46,0,2.35,2.35,0,0,0-2.36,2.35,2.39,2.39,0,0,0,.69,1.67,2.34,2.34,0,0,0,1.66.69,2.4,2.4,0,0,0,1.76-.77l0,0a5.8,5.8,0,0,0,.79-1.44c-.17-.42-.3-.76-.33-.85v0a2.37,2.37,0,0,0-1.77-1.53m-1,5.06a2.79,2.79,0,1,1,3.19-3.65v0c0,.12.1.27.16.42.06-.15.11-.3.16-.42h0a2.79,2.79,0,0,1,2.64-1.88,2.73,2.73,0,0,1,2,.82,2.77,2.77,0,0,1,.81,2,2.73,2.73,0,0,1-.82,2A2.8,2.8,0,0,1,37.32,31h0a4.62,4.62,0,0,1-.71-1.21A5,5,0,0,1,35.89,31h0a2.8,2.8,0,0,1-2.09.92,2.61,2.61,0,0,1-.52,0"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Iconos - Cards - Kolo interno") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.16-132.26a2.25,2.25,0,0,1-2.09,1.42,2.26,2.26,0,0,1-2.28-2.25,2.27,2.27,0,0,1,2.26-2.28,2.25,2.25,0,0,1,2.1,1.41,1.74,1.74,0,0,1,1-.71,3.47,3.47,0,0,0-3.09-1.89,3.46,3.46,0,0,0-3.46,3.44,3.47,3.47,0,0,0,3.46,3.48,3.5,3.5,0,0,0,3.09-1.91,1.79,1.79,0,0,1-1-.71"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.41,
    y: -178.73,
    width: 326.48,
    height: 197.93
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M33.55,36c-8.94,0-8.92-13.87,0-13.87a6.54,6.54,0,0,1,4.29,1.45.38.38,0,0,0,.63-.29v-7a.39.39,0,0,0-.39-.39H11.92a.39.39,0,0,0-.39.39V38.65a.39.39,0,0,0,.39.39H38.08a.39.39,0,0,0,.39-.39V34.84a.38.38,0,0,0-.64-.29A6.53,6.53,0,0,1,33.55,36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M44.12,14.79a1.39,1.39,0,0,0-.69-.82L25.74,4.88a1.41,1.41,0,0,0-1.28,0L6.58,14A1.41,1.41,0,0,0,6,15.86a1.43,1.43,0,0,0,1.89.62L25.09,7.7l17.05,8.77a1.4,1.4,0,0,0,2-1.68Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 26.41,
    y: 21.85,
    width: 13.99,
    height: 14.58
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 35.97,
    y: 25.66,
    width: 6.91,
    height: 6.91
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 30.36,
    y: 25.65,
    width: 6.91,
    height: 6.91
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 29.22,
    y: 24.53,
    width: 14.79,
    height: 9.19
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 6.8,
    y: 39.04,
    width: 35.99,
    height: 5.51,
    rx: 0.51,
    ry: 0.51
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.98fe611fb6ad044b3be7346abf056f7d.svg";
export { ForwardRef as ReactComponent };